export default "__VITE_ASSET__jWqur36q__"